export default __webpack_public_path__ + "images/SummerTimeBackground.web.png";